import { useEffect, useState } from 'react';
import { billingApi } from '../lib/billingApi';
import { hasPro } from '../../shared/monetization';

export default function useBillingStatus(userId) {
  const [state, setState] = useState({ userId: null, isPro: false, loading: true });
  useEffect(() => {
    let active = true;
    let pending = false;
    let timer;
    let attempts = 0;
    const returning = new URLSearchParams(window.location.search).get('billing') === 'success';
    const refresh = async () => {
      if (!active || pending) return;
      pending = true;
      let confirmed = false;
      try {
        const result = await billingApi('/api/billing/status');
        confirmed = result.isPro === true && hasPro(result.subscription, Date.now(), result.config?.trialEnabled);
        if (active) setState({ userId, isPro: confirmed, canManage: result.canManage === true, subscription: result.subscription, loading: false });
      } catch {
        if (active) setState({ userId, isPro: false, loading: false });
      } finally {
        pending = false;
        attempts += 1;
        if (active) {
          clearTimeout(timer);
          timer = setTimeout(refresh, returning && !confirmed && attempts < 24 ? 2500 : 60000);
        }
      }
    };
    refresh();
    window.addEventListener('focus', refresh);
    return () => { active = false; clearTimeout(timer); window.removeEventListener('focus', refresh); };
  }, [userId]);
  return state.userId === userId ? state : { isPro: false, loading: true };
}
